import gql from 'graphql-tag';

export default gql`
  fragment contactFragment on Contact {
    id
    firstName
    lastName
    email
    tel
    message
  }
`;
